export default theme => {
  return {
    title: {
      padding: "16px 16px 0px 16px",
      display: "flex",
      placeItems: "center flex-start",
    },
    card: {
      borderTop: `4px solid ${theme.palette.primary.main}`,
    },
    crewCard: {
      display: "flex",
      justifyContent: "flex-end",
      zoom: 0.6,
      pointerEvents: "none",
    },
    placeIcon: {
      width: "0.7em",
      marginLeft: -2,
    },
    placeName: {
      fontSize: 10,
      display: "inline-block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    badgeWrapper: {
      height: 65,
      width: 65,
      boxShadow:
        "0px 0px 0px -1px rgba(0, 0, 0, 0.1), 0px 2px 16px 0px rgba(0, 0, 0, 0.1), 0px 0px 2px 0px rgba(0, 0, 0, 0.1)",
      backgroundColor: theme.palette.secondary.main,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 2,
    },
    badgeImage: {
      height: 55,
    },
    boxIcon: {
      fontSize: "1.3em",
    },
    icons: {
      display: "flex",
      alignItems: "center",
      color: theme.palette.grey[400],
      justifyContent: "space-between",
      width: "80px",
      zoom: 1.2,
    },
    rating: {
      marginLeft: -theme.spacing(1),
    },
    legend: {
      position: "fixed",
      bottom: 0,
      right: 0,
      width: "50%",
      maxWidth: "500px",
      transform: "translateX(100%)",
      transition: "transform 200ms ease-in-out",
      zIndex: 1,
      [theme.breakpoints.down("xs")]: {
        width: "80%",
      },
    },
    legendOpen: {
      position: "fixed",
      right: 0,
      bottom: 0,
      width: "50%",
      maxWidth: "500px",
      transform: "translateX(0%)",
      transition: "transform 200ms ease-in-out",
      zIndex: 10,
      [theme.breakpoints.down("xs")]: {
        width: "80%",
      },
    },
    sectionName: {
      fontWeight: "600",
    },
    legendContent: {
      height: "75vh",
      overflow: "auto",
    },
    centerContent: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    mobileColumnReverse: {
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column-reverse",
      },
    },
  }
}
